// extracted by mini-css-extract-plugin
export default {"container":"AdditionalColumnsPopup__container__KrqQZ","content":"AdditionalColumnsPopup__content__bmqoQ","action":"AdditionalColumnsPopup__action__fkFqw"};